import { Play } from "lucide-react";

export const SeasonCard = ({ season, onClick, index }) => {
  const defaultPoster = "https://images.unsplash.com/photo-1574867022210-bd9ecc413bf3?crop=entropy&cs=srgb&fm=jpg&q=85";
  
  return (
    <div
      onClick={() => onClick(season.slug || season.id)}
      className="group cursor-pointer animate-fade-in opacity-0"
      style={{ animationDelay: `${index * 0.1}s`, animationFillMode: "forwards" }}
      data-testid={`season-card-${season.id}`}
    >
      {/* Poster Container - Hand drawn style with jump animation */}
      <div className="relative aspect-[2/3] overflow-hidden bg-black card-jump hand-drawn-subtle group"
           style={{ borderWidth: '4px', borderColor: '#fff', borderStyle: 'solid' }}>
        {/* Poster Image */}
        <img
          src={season.thumbnail || defaultPoster}
          alt={season.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-300" />
        
        {/* Play Overlay */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-16 h-16 rounded-full bg-[#E91E8C] flex items-center justify-center transform scale-50 group-hover:scale-100 transition-transform duration-300 shadow-lg border-2 border-white">
            <Play size={28} className="text-white fill-white ml-1" />
          </div>
        </div>

        {/* Season Title at Bottom */}
        <div className="absolute bottom-0 left-0 right-0 p-4 text-center">
          <h3 className="text-lg font-black text-white drop-shadow-lg uppercase tracking-wide">
            {season.title}
          </h3>
          {season.description && (
            <p className="text-xs text-white/80 mt-1 line-clamp-2 drop-shadow font-medium">
              {season.description}
            </p>
          )}
        </div>

        {/* Colored accent line on hover */}
        <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-[#FFE500] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
      </div>
    </div>
  );
};
